// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3iM88","signatureButtonsRight":"ModalSign_signatureButtonsRight__1QGQC"};